<div>
  <div class="empty-list-header">
    <div class="header-content">
      <div class="icon-wrapper">
        <div class="icon-circle">
          <img src="../../../../../assets/roi/reindex-empty.png" />
        </div>
      </div>
      <h3>You do not have any reindexes to show.</h3>
      <p>
        <span>Restore data from your AWS S3 archive.</span>
      </p>
      <div>
        <cgx-button
          label="REINDEX ARCHIVE"
          size="lg"
          textNoWrap
          srcIconStart="assets/roi/icon-reindex.svg"
          width="216px"
          [srcIconStartStyle]="{ width: 24, height: 24 }"
          [disabled]="btnDisabled"
          (press)="openEditor.emit()"
        ></cgx-button>
      </div>
    </div>
  </div>
</div>
